import * as React from 'react';

import { useIntl } from 'react-intl';

import Link from 'components/link';
import { routes } from 'utils/routing';

import { ModalBody } from '../send-gift.styled';

export const GiftSentErrorBody = ({ email, giftName }: { email: string; giftName: string }) => {
  const { formatMessage } = useIntl();
  return (
    <ModalBody>
      <p>
        {formatMessage(
          { id: 'giftSentError' },
          {
            email: <b>{email}</b>,
            gift: <b>{giftName}</b>,
            supportLink: (
              <Link isSelected to={routes.support}>
                {formatMessage({ id: 'support' })}
              </Link>
            ),
          }
        )}
      </p>
    </ModalBody>
  );
};
